<template>
  <QDialog ref="dialog" @hide="$emit('hide')">
    <QCard class="rounded-borders-lg" :style="{ 'min-width': minWidth }">
      <div class="row full-width justify-end q-px-md q-pt-md">
        <SAIIconBtn @click="hide" color="grey-6" />
      </div>
      <h4 class="text-weight-bold text-primary text-center">
        Payroll deduction
      </h4>
      <p class="q-mt-md q-pb-lg q-px-lg text-center">
        If your car is delivered after your payroll cut off date, then we may
        need to take a double deduction in the first cycle. To avoid this we can
        delay the delivery of your car to align with your payroll cycle.
        <span v-if="contactNumber">
          Call
          <SAILink :href="`tel:${contactNumber}`">
            {{ contactNumber }}
          </SAILink>
          for more information.
        </span>
      </p>
    </QCard>
  </QDialog>
</template>

<script>
import { QDialog, QCard } from 'quasar';
import { SAIIconBtn, SAILink } from 'ecx.saigon.ui.common';

export default {
  name: 'PayrollDialog',
  props: {
    contactNumber: String,
    minWidth: {
      type: String,
      default: '536px'
    }
  },
  methods: {
    show() {
      this.$refs.dialog.show();
    },
    hide() {
      this.$refs.dialog.hide();
    }
  },
  components: {
    QDialog,
    QCard,
    SAIIconBtn,
    SAILink
  }
};
</script>
